import { atom } from "recoil";
import { IFormValuesJimpiFilter, IFormValuesTuiFilter } from "./types";

export const jimpiFilterState = atom<IFormValuesJimpiFilter | null>({
    key: 'jimpiFilterState',
    default: null
});

export const tuiFilterState = atom<IFormValuesTuiFilter | null>({
    key: 'tuiFilterState',
    default: null
});